import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BookingHotel } from '@app/services/api/api.types';

@Component({
  selector: 'booking-hotel-card',
  templateUrl: './booking-hotel-card.component.html',
  styleUrls: ['./booking-hotel-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingHotelCardComponent {
  @Input() data: BookingHotel;
  @Input() isClickable: boolean = true;
}
